import React from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import { SxProps } from '@mui/material/styles';

interface GuidelinesSectionProps {
  guidelines: string;
  onGuidelinesChange: (value: string) => void;
  autoReplyEnabled: boolean;
  onAutoReplyChange: (value: boolean) => void;
  saving: boolean;
  onSave: () => void;
  labels: {
    placeholder: string;
    autoReplyLabel: string;
    saving: string;
  };
  saveLabel: string;
  switchSx?: SxProps;
}

const GuidelinesSection: React.FC<GuidelinesSectionProps> = ({
  guidelines,
  onGuidelinesChange,
  autoReplyEnabled,
  onAutoReplyChange,
  saving,
  onSave,
  labels,
  saveLabel,
  switchSx,
}) => (
  <Stack spacing={2}>
    <TextField
      multiline
      minRows={8}
      placeholder={labels.placeholder}
      value={guidelines}
      onChange={e => onGuidelinesChange(e.target.value)}
      fullWidth
    />
    <FormControlLabel
      sx={switchSx}
      control={
        <Switch
          checked={!!autoReplyEnabled}
          onChange={(_, v) => onAutoReplyChange(v)}
        />
      }
      label={labels.autoReplyLabel}
    />
    <Box>
      <Button
        variant="contained"
        color="primary"
        onClick={onSave}
        disabled={saving}>
        {saving ? labels.saving : saveLabel}
      </Button>
    </Box>
  </Stack>
);

export { GuidelinesSection };
